import {flatten} from 'lodash-es';

import {IColumnSortData, TColumnSortForRequest} from '../../table-column-menu-types';

export const adaptSortDataForRequest = (sort: IColumnSortData['sort']) => {
    const sortAdapted = flatten(Object.entries(sort)
        .filter(([, s]) => s?.order)
        .map((([columnKey, s]) => {
            const sortForRequest: TColumnSortForRequest = {
                columnName: columnKey,
                order: s?.order === 'ascend' ? 'ASC' : 'DESC',
            };
            if (s?.multiple) sortForRequest.index = s?.multiple;
            return sortForRequest;
        })));

    return sortAdapted;
};

export const adaptSortRequestDataToTableFormat = (sort: TColumnSortForRequest[]) => {
    const sortData: IColumnSortData['sort'] = {};

    sort.forEach(v => {
        if (v.order) {
            sortData[v.columnName] = {
                multiple: v.index,
                order: v.order === 'ASC' ? 'ascend' : 'descend',
            };
        }
    });

    return sortData;
};
